import React from 'react';
import { CustomDistrictBreakdown } from '../../../shared';
import { useSelector } from 'react-redux';

const MapBreakDown = () => {
    const { company } = useSelector((state) => state.company);
    const {
        overallMapCount,
        stateBreakdownUSAMapData,
        stateMapBarSeries,
        isGeographyLoading
    } = useSelector((state) => state.webMatrix);
    return (
        <CustomDistrictBreakdown
            companyId= {company.id}
            distributionRegion= {[]}
            districtBreakdownUSAMapData= {stateBreakdownUSAMapData}
            hideDistrictMap= {[150,61,165,94]}
            isLoading= {isGeographyLoading}
            key={overallMapCount}
            overallHeading=" Overall Count"
            overallPhysicians= {'0'}
            showOverallCount={false}
            stateBreakdownUSAMapData= {stateBreakdownUSAMapData}
            stateDistributionRegion= {stateMapBarSeries}
            stateMapSeries= {stateBreakdownUSAMapData}
            stateOverallPhysicians= {overallMapCount}
            title="Website Visits Broken Down by State"
        />
    );
};

export default MapBreakDown;
